import {
  call,
  cancel,
  delay,
  fork,
  put,
  take,
  takeLatest,
} from 'redux-saga/effects';
import {
  DO_RESTORE_DELETED_BUSINESS,
  DO_RESTORE_DELETED_BUSINESS_SEARCH,
  RESTORE_DELETED_BUSINESS_DO_SHOW_LOG,
  RESTORE_DELETED_BUSINESS_LOG_CHANGE_PAGE,
  RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN,
} from 'state/actionTypes';
import * as api from 'api/restoreDeletedBusiness';
import {
  clearBusinessInfo,
  clearLogErrors,
  resetLogData,
  setBusinessInfo,
  setLogData,
  setLogErrors,
  setLogIsLoading,
  setLogModalShown,
  setLogPage,
  setSearchError,
  setSearchLoading,
  setSubmitError,
  setSubmitLoading,
  setSubmitSuccess,
} from 'state/restoreDeletedBusiness/actions';

export function* searchBusiness({ payload }) {
  const { businessId } = payload;
  yield put(setSearchLoading(true));
  yield put(setSearchError(null));
  yield put(clearBusinessInfo());
  yield put(setSubmitSuccess(false));
  try {
    const response = yield call(api.getBusinessById, businessId);
    yield put(setBusinessInfo(response.data));
  } catch (e) {
    yield put(setSearchError(e.message));
  } finally {
    yield put(setSearchLoading(false));
  }
}

export function* doRestoreBusiness({ payload }) {
  const { businessId, ticketLink, notes } = payload;
  yield put(setSubmitLoading(true));
  yield put(setSubmitError(null));
  yield put(setSubmitSuccess(false));
  try {
    yield call(api.restoreBusiness, businessId, ticketLink, notes);
    yield put(setSubmitSuccess(true));
  } catch (e) {
    yield put(setSubmitError(e.message));
  } finally {
    yield put(setSubmitLoading(false));
  }
}

function* logModalTask() {
  while (true) {
    const { page } = (yield take(
      RESTORE_DELETED_BUSINESS_LOG_CHANGE_PAGE
    )).payload;
    yield put(setLogIsLoading(true));
    yield put(clearLogErrors());
    yield put(resetLogData());
    try {
      const {
        data: {
          data: { internal_tools_activities: activities },
          paging,
        },
      } = yield call(api.getRestoreDeletedBusinessLogs, page, 20);
      yield put(setLogData(activities, paging));
    } catch (e) {
      yield put(setLogErrors(e.message));
    } finally {
      yield put(setLogIsLoading(false));
    }
  }
}

export function* doShowLogs() {
  const task = yield fork(logModalTask);
  yield delay(30);
  yield put(setLogPage(1));
  yield put(setLogModalShown(true));
  let closeModalRequest;
  do {
    closeModalRequest = (yield take(RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN))
      .payload;
  } while (closeModalRequest.shown);
  yield cancel(task);
}

export default function*() {
  yield takeLatest(DO_RESTORE_DELETED_BUSINESS_SEARCH, searchBusiness);
  yield takeLatest(DO_RESTORE_DELETED_BUSINESS, doRestoreBusiness);
  yield takeLatest(RESTORE_DELETED_BUSINESS_DO_SHOW_LOG, doShowLogs);
}
